import {
  HTTP_CP_SignUp_Request_Property,
  HTTP_CP_SignUp_Request_Property_AdditionalPropertyData,
  HTTP_CP_SignUp_Request_Property_PropertyValue,
  HTTP_CP_SignUp_Request_SmartSearch_BuyProperty,
} from '@api-new/authservice';
import {
  DATA_Address,
  ENUM_ManualPropertyValueType,
  ENUM_ManualPropertyValueTypeInspectionSurveyor,
  ENUM_PropertyInvestmentType,
  ENUM_SmartSearchBuyPropertyType,
} from '@api-new/common';
import { PropertyFormValues } from '@app/sign-up/forms/property.form';
import { addressFormToAddressDataModelAdapter } from '@shared-lib/components/forms/address-form/adapters/address-form-to-address-data-model.adapter';
import { SmartSearchFormValues } from '@shared-lib/forms/sign-up-smart-search/smart-search.form';

export const signUpPropertyToHttpRequestAdapter = (property: PropertyFormValues | null): HTTP_CP_SignUp_Request_Property | undefined => {
  if (property == null) return undefined;

  const address = addressFormToAddressDataModelAdapter(property.address)?.address;

  const propertyValue: HTTP_CP_SignUp_Request_Property_PropertyValue | undefined = property
    ? {
        year: property.propertyValuation.date.getFullYear(),
        month: property.propertyValuation.date.getMonth() + 1,
        manualValue: property.propertyValuation.valuation,
        manualPropertyValueType: property.propertyValuation.valuationSource,
        manualPropertyValueTypeInspectionSurveyor:
          property.propertyValuation.valuationSource === ENUM_ManualPropertyValueType.MANUAL_PROPERTY_VALUE_TYPE_INSPECTION &&
          property.propertyValuation.surveyor != null
            ? property.propertyValuation.surveyor
            : undefined,
        manualPropertyValueTypeInspectionSurveyorOther:
          property.propertyValuation.surveyor ===
            ENUM_ManualPropertyValueTypeInspectionSurveyor.MANUAL_PROPERTY_VALUE_TYPE_INSPECTION_SURVEYOR_OTHER &&
          property.propertyValuation.surveyorOtherValue != null
            ? property.propertyValuation.surveyorOtherValue
            : undefined,
      }
    : undefined;

  const additionalPropertyData: HTTP_CP_SignUp_Request_Property_AdditionalPropertyData | undefined = {
    propertyType: property.addressDetails?.propertyType ?? undefined,
    constructionYear: property.addressDetails?.constructionYear ?? undefined,
    numberOfBedrooms: property.addressDetails?.numberOfBedrooms ?? undefined,
    ownershipShare: property.additionalInfo.ownershipShare != null ? property.additionalInfo.ownershipShare / 100 : undefined,
    tenure: property.addressDetails?.tenure ?? undefined,
    isCompanyOwned: property.additionalInfo.isCompanyOwned,
    companyOwnedCompanyRegisteredName: property.additionalInfo.isCompanyOwned
      ? property.additionalInfo.companyOwnedCompanyRegisteredName
      : undefined,
    companyOwnedCompanyRegistrationNumber: property.additionalInfo.isCompanyOwned
      ? property.additionalInfo.companyOwnedCompanyRegistrationNumber
      : undefined,
  };

  return {
    address,
    investmentType: property.investmentType,
    propertyValue,
    additionalPropertyData,
  };
};

export const signUpPropertyBuyAdapter = (
  smartSearch: SmartSearchFormValues,
  smartSearchBuyPropertyType: ENUM_SmartSearchBuyPropertyType,
  investmentType: ENUM_PropertyInvestmentType,
): HTTP_CP_SignUp_Request_SmartSearch_BuyProperty => {
  return {
    propertyValue: smartSearch.basicDetails.propertyPrice,
    deposit: smartSearch.basicDetails.deposit,
    termInMonths: smartSearch.basicDetails.newTermInMonths,
    mortgageRepaymentType: smartSearch.liveResults.repaymentType,
    smartSearchBuyPropertyType: smartSearchBuyPropertyType,
    propertyInvestmentType: investmentType,
  };
};

export const signUpPropertyToResidentialAddressAdapter = (propertyForm: PropertyFormValues | null): DATA_Address | undefined => {
  const addressSourceMap = {
    [ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_RESIDENTIAL]: propertyForm?.address,
    [ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_BUY_TO_LET]: propertyForm?.residentialAddress,
  };

  const sourceAddress = propertyForm ? addressSourceMap[propertyForm.investmentType] : null;
  return sourceAddress ? addressFormToAddressDataModelAdapter(sourceAddress)?.address : undefined;
};
